import styled from "styled-components/macro";
import { COLOR } from "../styles";
import { ReactComponent as Cluster } from "../assets/cluster.svg";
import { ReactComponent as Pin } from "../assets/pin.svg";
import { ReactComponent as PinSelected } from "../assets/pin-selected.svg";
import { ReactComponent as BoxReturner } from "../assets/box-returner-filled.svg";

export const VytalMapInnerContainer = styled.div`
  width: 100%;
`;

export const ClusterContainer = styled.div`
  width: 50px;
  height: 50px;
  position: relative;
  top: -50px;
  left: -20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const ClusterCount = styled.div`
  font-size: 14px;
  font-weight: 600;
  font-family: "Inter", sans-serif;
  color: ${COLOR.PIN_CLUSTER_FOREGROUND};
  position: relative;
  top: -2px;
`;

export const ClusterIcon = styled(Cluster)`
  position: absolute;
  z-index: -1;
  circle { fill: ${COLOR.PIN_CLUSTER_BACKGROUND}; stroke: ${COLOR.PIN_CLUSTER_BORDER} }
`;

export const PinContainer = styled(Pin)`
  width: 36px;
  height: 40px;
  position: relative;
  top: -40px;
  left: -18px;
  cursor: pointer;
  circle { fill: ${COLOR.PIN_STORE_BACKGROUND}; stroke: ${COLOR.PIN_STORE_BORDER} }
  path { fill: ${COLOR.PIN_STORE_FOREGROUND} }
`;

export const PinContainerSelected = styled(PinSelected)`
  width: 36px;
  height: 40px;
  position: relative;
  top: -40px;
  left: -18px;
  cursor: pointer;
  circle { fill: ${COLOR.PIN_STORE_SELECTED_BACKGROUND}; stroke: ${COLOR.PIN_STORE_SELECTED_BORDER}; }
  path { fill: ${COLOR.PIN_STORE_SELECTED_FOREGROUND}; }
`;

const ReturnStationPinWrapper = styled.div`
  width: 36px;
  height: 40px;
  position: relative;
  top: -40px;
  left: -18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ReturnStationCircle = styled.div`
  width: 29px;
  height: 29px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 1px 1.4px rgba(0, 0, 0, 0.2);
  background: ${p => p.$selected ? COLOR.PIN_STORE_SELECTED_BACKGROUND : COLOR.PIN_STORE_BACKGROUND};
  border: 0.5px solid ${p => p.$selected ? COLOR.PIN_STORE_SELECTED_BORDER : COLOR.PIN_STORE_BORDER};
`;

const ReturnStationIcon = styled(BoxReturner)`
  width: 12px;
  height: 12px;
  color: ${p => p.$selected ? COLOR.PIN_STORE_SELECTED_FOREGROUND : COLOR.PIN_STORE_FOREGROUND};
`;

export const ReturnStationPinContainer = (props) => (
  <ReturnStationPinWrapper {...props}>
    <ReturnStationCircle>
      <ReturnStationIcon />
    </ReturnStationCircle>
  </ReturnStationPinWrapper>
);

export const ReturnStationPinContainerSelected = (props) => (
  <ReturnStationPinWrapper {...props}>
    <ReturnStationCircle $selected>
      <ReturnStationIcon $selected />
    </ReturnStationCircle>
  </ReturnStationPinWrapper>
);
